import React from 'react';
import { useConstructorStore } from '../store/constructorStore';
import { t } from '../i18n';

const countries = [
  { code: 'kz', label: 'country_kz' },
  { code: 'ru', label: 'country_ru' },
  { code: 'uz', label: 'country_uz' },
  { code: 'kg', label: 'country_kg' },
];

const cities: Record<string, { code: string; label: string }[]> = {
  kz: [
    { code: 'astana', label: 'city_astana' },
    { code: 'almaty', label: 'city_almaty' },
    { code: 'shymkent', label: 'city_shymkent' },
    { code: 'karaganda', label: 'city_karaganda' },
    { code: 'aktau', label: 'city_aktau' },
    { code: 'atyrau', label: 'city_atyrau' },
    { code: 'other', label: 'city_other' },
  ],
  ru: [
    { code: 'moscow', label: 'Москва' },
    { code: 'spb', label: 'Санкт-Петербург' },
    { code: 'other', label: 'Другой' },
  ],
  uz: [
    { code: 'tashkent', label: 'Toshkent' },
    { code: 'samarkand', label: 'Samarqand' },
    { code: 'other', label: 'Boshqa' },
  ],
  kg: [
    { code: 'bishkek', label: 'Бишкек' },
    { code: 'osh', label: 'Ош' },
    { code: 'other', label: 'Башка' },
  ],
};

export const Step2Location: React.FC = () => {
  const { country, city, language, setField } = useConstructorStore();

  const selectStyle: React.CSSProperties = {
    width: '100%', padding: '12px 14px', border: '1px solid #ddd',
    borderRadius: 10, fontSize: 16, background: 'white', outline: 'none',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6, color: '#555',
  };

  const groupStyle: React.CSSProperties = { marginBottom: 20 };

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>{t('step2_title', language)}</h2>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('country', language)}</label>
        <select style={selectStyle} value={country}
          onChange={(e) => { setField('country', e.target.value); setField('city', ''); }}>
          {countries.map((c) => (
            <option key={c.code} value={c.code}>{t(c.label, language)}</option>
          ))}
        </select>
      </div>

      <div style={groupStyle}>
        <label style={labelStyle}>{t('city', language)}</label>
        <select style={selectStyle} value={city}
          onChange={(e) => setField('city', e.target.value)}>
          {(cities[country] || []).map((c) => (
            <option key={c.code} value={c.code}>
              {c.label.startsWith('city_') ? t(c.label, language) : c.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
